import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  name: 'heartbeat',
})
export default class Heartbeat extends Vue {
  msg: string = 'Loading...'

  created () {
    (<any>this.$options).interval = setInterval(this.heartbeat, 30000)
    console.log((<any>this.$options).interval !== null)  
  }

  beforeDestroy () {
    clearInterval((<any>this.$options).interval)
  }

  private heartbeat (): void {
    fetch(`${process.env.VUE_APP_API_URL}/heartbeat`).then(res => res.json()).then((response) => {
      console.log('Heartbeat: response = %j', response)
      this.msg = `${(<any>response).name} : ${new Date()}`
  })
}
}
